<template>
  <div class="sdgs-container">
    <div class="header">
      UNSER PROGRAMM
    </div>
    <div class="separator"></div>
    
    <programme/>

    <div class="back-button" @click="goBack()">
      <i class="fas fa-chevron-circle-left"></i>
    </div>
   
  </div>
</template>

<script>
import Programme from "@/components/Programme.vue"

export default {
  name: 'Programm',
  components: {
    Programme,
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.sdgs-container {
  position: relative;
  @include gradient;
  min-height: 100%;
}

.back-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  font-size: 40px;
  color: black;
}


</style>
